import {accountEditEndpoints} from "../../requests/api-endpoints";
import moment from "moment/moment";
import {DateFormats} from "../../components/constants/securspace-constants";
import request from "../../util/SuperagentUtils";

/**
 * Parameters for requesting account reports.
 *
 * @property {'true' | 'false' | '' | undefined | null} activated - a boolean string for filtering by activation status
 * @property {string} accountId - The account ID used for filtering
 */
export interface RequestParams {
  page?: string,
  size?: string,
  companyName?: string;
  accountId: string;
  activated: 'true' | 'false' | '' | undefined | null;
  type: string;
  email: string;
  username: string;
  creationDate: string;
  sortBy?: string,
  sortDir?: 'asc' | 'desc',
  isPageable?: boolean
}

const getAccountReportUrlParams = (requestParams: RequestParams) => {

  const {
    page,
    size,
    accountId,
    creationDate,
    email,
    sortBy,
    activated,
    username,
    type,
    sortDir,
    isPageable = false
  } = requestParams;

  const params = new URLSearchParams();

  if (isPageable) {
    params.append("page", page ? page : "0");
    params.append("size", size ? size : "10");
  }
  if (accountId) {
    params.append("accountId", accountId);
  }
  if (creationDate) {
    params.append("creationDate", moment(creationDate).format(DateFormats.DAY));
  }
  if (type) {
    params.append("type", type)
  }
  if (email) {
    params.append("email", email)
  }
  if (activated) {
    params.append("activated", activated)
  }
  if (username) {
    params.append("username", username)
  }
  if (sortBy && sortBy !== 'none') {
    params.append("sortBy", sortBy)
  }
  if (sortDir) {
    params.append("sortDir", sortDir)
  }

  return params;
}

export const getAccountReportDownload = (searchParams: RequestParams) => {
  return `${accountEditEndpoints.adminAccountReport.getAccountReportCSV}?${getAccountReportUrlParams(searchParams).toString()}`;
};

export const deleteAccount = (accountId: string) => {
  return request.delete(`${accountEditEndpoints.admin.delete}/${accountId}`);
};

export const editAccountType = (accountId: string) => {
  return request.post(`${accountEditEndpoints.admin.editType}/${accountId}`);
};

export const changeAccountStatus = (accountId: string) => {
  return request.post(`${accountEditEndpoints.admin.changeStatus}/${accountId}`);
};
